<template>
  <div class="home">
    <div class="home_bg">
      <img class="show" src="../assets/cont_bg.png" alt="">
      <img class="hide"src="../assets/mobile_bg.png" alt="">
    </div>
    <div class="home_content">
      <div class="intro">
        <!-- <img class="intro_logo" src="../assets/intro_img1.png" alt=""> -->
        <div class="intro_title">{{ $t('home.intro.title') }}</div>
        <!-- <div class="intro_text">{{ $t('home.intro.text3') }}</div> -->
        <div class="intro_text">{{ $t('home.intro.text4') }}</div>
        <!-- <div class="intro_countdown">
          <p><span>{{ countDown.days }}</span> <span class="text">{{ $t('day') }}</span></p>
          <p><span>{{ countDown.hours }}</span> <span class="text">{{ $t('hour') }}</span></p>
          <p><span>{{ countDown.mins }}</span> <span class="text">{{ $t('min') }}</span></p>
        </div> -->
        <div class="intro_tips">
          <img class="icon_tip" src="../assets/tips.png" alt="">
          <p class="icon_text">{{ $t('home.intro.tip') }}</p>
        </div>
      </div>
      <describe></describe>
      <rule></rule>
      <ecology></ecology>
      <coverage></coverage>
      <trackpage></trackpage>
      <faqs></faqs>
      <buy></buy>
      <potential></potential>
      <report></report>
      <ytbvideo></ytbvideo>
      <prompt></prompt>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { defineComponent, ref, onMounted, computed, watch, inject } from "vue";
  import { useStore } from "vuex"
  import { useI18n } from "vue-i18n";
  import describe from "@/components/describe.vue";
  import rule from "@/components/rule.vue";
  import ecology from "@/components/ecology.vue";
  import coverage from "@/components/coverage.vue";
  import trackpage from "@/components/track.vue";
  import faqs from "@/components/faqs.vue";
  import buy from "@/components/buy.vue";
  import potential from "@/components/potential.vue";
  import report from "@/components/report.vue";
  import ytbvideo from "@/components/ytbvideo.vue";
  import prompt from "@/components/prompt.vue";

  export default defineComponent({
    name: 'Home',
    components: {
      describe,
      rule,
      ecology,
      coverage,
      trackpage,
      faqs,
      buy,
      potential,
      report,
      ytbvideo,
      prompt
    },
    setup() {
      const { t, locale } = useI18n()
      const message = inject( '$message')
      const store = useStore()
      let lan = computed(() => store.state.lan)
      const countDown = ref({
        days: 0,
        hours: 0,
        mins: 0,
        secs: 0
      })
      const getTime = async (endTime) => {
        const endTimeStamp = new Date(endTime).getTime();
        const interval = setInterval(() => {
          const now = new Date().getTime();
          const distance = endTimeStamp - now;
          if (distance < 0) {
            clearInterval(interval);
            return;
          }
          countDown.value.days = Math.floor(distance / (1000 * 60 * 60 * 24));
          countDown.value.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          countDown.value.mins = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          countDown.value.secs = Math.floor((distance % (1000 * 60)) / 1000);
          
          if (countDown.value.days < 10) {
            countDown.value.days = '0' + countDown.value.days
          }
          if (countDown.value.hours < 10) {
            countDown.value.hours = '0' + countDown.value.hours
          }
          if (countDown.value.mins < 10) {
            countDown.value.mins = '0' + countDown.value.mins
          }
        }, 1000);
      }
      const timingTime = async (startTime) => {
        setInterval(() => {
          let start_time = new Date(startTime).getTime()
          let current_time = new Date().getTime()
          let difference = current_time - start_time
          let m = Math.floor(difference/1000)
          countDown.value.secs = m % 60 // 秒
          let f = Math.floor(m/60)
          countDown.value.mins = f % 60 // 分
          let s = Math.floor(f/60)
          countDown.value.hours = s % 24 // 时
          countDown.value.days = Math.floor(s/24)
          if (countDown.value.days < 10) {
            countDown.value.days = '0' + countDown.value.days
          }
          if (countDown.value.hours < 10) {
            countDown.value.hours = '0' + countDown.value.hours
          }
          if (countDown.value.mins < 10) {
            countDown.value.mins = '0' + countDown.value.mins
          }
        }, 1000)
      }
      const dlc_price = ref(0.003)
      const pre_num = ref(1)
      const pre_num1 = ref(2)
      const process = ref(30)
      
      onMounted(() => {
        getTime('2024-09-11T11:00:00Z')
      });
      return {
        lan,
        countDown,
        dlc_price,
        pre_num, 
        pre_num1,
        process
      };
    }
  })
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  margin: auto;
  max-width: 1440px;
  min-width: 1200px;
  position: relative;
  font-style: normal;
  padding-bottom: 70px;
  .show {
    display: block;
  }
  .hide {
    display: none;
  }
  .home_bg {
    position: absolute;
    top: -72px;
    width: 100%;
    display: flex;
    margin: auto;
    height: 500px;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    img {
      object-fit: cover;
    }
  }
  .home_content {
    position: relative;
    z-index: 2;
    width: 100%;
    min-width: 1200px;
    .intro {
      width: 100%;
      display: flex;
      align-items: center;
      padding-bottom: 80px;
      flex-direction: column;
      justify-content: center;
      .intro_logo {
        width: 325px;
        height: 38px;
        margin: 50px 0 40px;
      }
      .intro_title {
        color: #fff;
        margin-top: 100px;
        font-size: 46px;
        font-weight: 600;
        line-height: 60px;
        text-align: center;
        margin-bottom: 15px;
        letter-spacing: 0.1em;
      }
      .intro_text {
        font-size: 24px;
        font-weight: 600;
        line-height: 40px;
        padding: 10px 30px;
        margin-bottom: 50px;
        border-radius: 20px;
        letter-spacing: 0.08em;
        backdrop-filter: blur(6px);
        color: rgba(255, 255, 255, 1);
        background: rgba(255, 255, 255, .1)
      }
      .intro_countdown {
        font-size: 80px;
        font-weight: 600;
        line-height: 37px;
        text-align: center;
        margin-bottom: 120px;
        // letter-spacing: 0.16em;
        color: rgba(255, 255, 255, 0.68);

        display: flex;
        align-items: center;
        justify-content: center;
        p {
          display: flex;
          margin: 0 20px;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          span {
            color: #03FF91;
            font-size: 110px;
            font-weight: 700;
            line-height: 106px;
            &.text {
              line-height: 1;
              font-size: 24px;
              font-weight: 500;
              padding: 6px 24px;
              border-radius: 20px;
              letter-spacing: 0.08em;
              backdrop-filter: blur(6px);
              color: rgba(255, 255, 255, 1);
              background: rgba(255, 255, 255, .1)
            }
          }
        }
      }
      .intro_tips {
        width: 100%;
        display: flex;
        padding: 11px;
        max-width: 1200px;
        border-radius: 20px;
        align-items: center;
        box-sizing: border-box;
        border: 1px solid rgba(255, 255, 255, .2); 
        .icon_tip {
          width: 42px;
          height: 42px;
        }
        .icon_text {
          flex: 1;
          font-size: 16px;
          font-weight: 500;
          line-height: 32px;
          text-align: right;
          letter-spacing: 0.16em;
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }
    .describe {
      display: flex;
      margin: auto;
      width: 1200px;
      flex-wrap: wrap;
      padding-bottom: 80px;
      justify-content: space-between;
      .desc_title {
        width: 100%;
        font-size: 38px;
        font-weight: 600;
        line-height: 50px;
        text-align: center;
        letter-spacing: 0em;
        margin-bottom: 15px;
        color: rgba(3, 255, 145, 1);
      }
      .desc_left {
        width: 660px;
        text-align: center;
        .left_title {
          font-size: 36px;
          font-weight: 600;
          // text-align: left;
          line-height: 48px;
          letter-spacing: 0em;
          margin-bottom: 20px;
          color: rgba(43, 179, 106, 1);
        }
        .left_text {
          font-size: 15px;
          font-weight: 400;
          // text-align: left;
          line-height: 26px;
          letter-spacing: 0.06em;
          color: rgba(255, 255, 255, 0.8);
        }
        .left_intro {
          margin-top: 20px;
          padding: 8px 40px;
          align-items: center;
          border-radius: 58px;
          display: inline-flex;
          background: rgba(54, 63, 94, 0.4);
          .left_intro_text {
            font-size: 14px;
            font-weight: 400;
            line-height: 26px;
            margin-right: 40px;
            letter-spacing: 0.02em;
            color: rgba(255, 255, 255, 0.6);
          }
          .left_intro_img {
            width: 179px;
            height: 26px;
            background: url(../assets/desc/img1.png) no-repeat 100%/100%;
          }
        }
        .left_btns {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          margin: 30px 0 38px;
          align-items: center;
          justify-content: space-around;
          .left_btn {
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            padding: 16px 40px;
            border-radius: 58px;
            font-size: 16px;
            font-weight: 600;
            line-height: 21px;
            letter-spacing: 0em;
            color: rgba(3, 255, 145, 1);
            background: rgba(38, 65, 52, 0.9);
            .left_btn_icon {
              width: 20px;
              height: 20px;
              margin-right: 5px;
              img {
                width: 20px;
                height: 20px;
              }
            }
          }
        }
        .left_video {
          width: 640px;
          height: 360px;
          padding: 20px;
          border-radius: 22px;
          box-sizing: border-box;
          background: rgba(54, 63, 94, 0.5);
          video {
            width: 600px;
            height: 320px;
          }
        }
      }
      .desc_right {
        width: 500px;
        height: 680px;
        display: flex;
        align-self: end;
        padding: 30px 20px;
        border-radius: 30px;
        align-items: center;
        flex-direction: column;
        box-sizing: border-box;
        justify-content: space-between;
        border: 8px solid rgba(46, 81, 60, 0.8);
        .width100 {
          width: 100%;
          display: flex;
          align-items: center;
          flex-direction: column;
        }
        .right_title {
          font-size: 28px;
          font-weight: 600;
          line-height: 28px;
          margin-bottom: 12px;
          letter-spacing: 0.06em;
          color: rgba(43, 179, 106, 1);
        }
        .right_text {
          font-size: 13px;
          font-weight: 400;
          line-height: 17px;
          letter-spacing: 0em;
          margin-bottom: 30px;
          color: rgba(255, 255, 255, 0.54);
        }
        .right_text1 {
          font-size: 12px;
          font-weight: 400;
          margin-top: 10px;
          line-height: 16px;
          letter-spacing: 0em;
          color: rgba(255, 255, 255, 0.6);
        }
        .right_desc {
          font-size: 16px;
          font-weight: 500;
          line-height: 26px;
          letter-spacing: 0em;
          color: rgba(255, 255, 255, 1);
        }
        .right_pro {
          width: 100%;
          height: 60px;
          padding: 6px;
          overflow: hidden;
          margin-top: 20px;
          border-radius: 30px;
          box-sizing: border-box;
          background: rgba(54, 63, 94, 0.8);
          .progress {
            height: 48px;
            max-width: 100%;
            font-size: 16px;
            font-weight: 600;
            text-align: center;
            letter-spacing: 0em;
            border-radius: 24px;
            align-items: center;
            display: inline-flex;
            justify-content: center;
            color: rgba(1, 1, 20, 1);
            background: linear-gradient(271.98deg, #2AB36A 4.13%, #68CC4F 114.86%);
          }
        }
        .right_btn1 {
          width: 100%;
          height: 50px;
          cursor: pointer;
          margin-top: 30px;
          border-radius: 58px;
          align-items: center;
          display: inline-flex;
          justify-content: center;
          background: rgba(38, 65, 52, 1);
          .btn1_icon {
            width: 22px;
            height: 22px;
            margin-right: 10px;
            img {
              width: 22px;
              height: 22px;
            }
          }
          p {
            font-size: 16px;
            font-weight: 500;
            letter-spacing: 0em;
            color: rgba(3, 255, 145, 1);
          }
        }
        .right_btn2 {
          width: 100%;
          height: 47px;
          cursor: pointer;
          font-size: 14px;
          margin-top: 55px;
          font-weight: 500;
          border-radius: 47px;
          letter-spacing: 0em;
          align-items: center;
          display: inline-flex;
          justify-content: center;
          color: rgba(3, 255, 145, 0.68);
          background: rgba(54, 63, 94, 0.5);
        }
        .right_community {
          width: 210px;
          display: flex;
          margin-top: 25px;
          align-items: center;
          justify-content: space-between;
          img {
            width: 44px;
            height: 44px;
            cursor: pointer;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .home {
    min-width: 600px;
    .show {
      display: none;
    }
    .hide {
      display: block;
    }
    .home_bg {
      img {
        object-fit: cover;
      }
      
    }
    .home_content {
      min-width: 600px;
      .intro {
        .intro_tips {
          width: 90%;
          padding: 11px;
          max-width: 1200px;
          align-items: center;
          box-sizing: border-box;
          border: 1px solid rgba(255, 255, 255, .2); 
          .icon_tip {
            width: 42px;
            height: 42px;
          }
          .icon_text {
            flex: 1;
            font-size: 16px;
            font-weight: 500;
            line-height: 32px;
            text-align: right;
            letter-spacing: 0.16em;
            color: rgba(255, 255, 255, 0.8);
          }
        }
      }
    }
  }
}
</style>
